import * as CouponPageActionTypes from '../actionTypes/CouponPageActionTypes';

const getCouponPageLoaded = () => ({
    type: CouponPageActionTypes.COUPON_PAGE_LOAD_READY,
    payload: { pageName: 'coupon' },
});

export default {
    getCouponPageLoaded,
};
